// useNavAuth.js
// Isolates auth state from the navbar so you can swap auth providers
// (JWT, Firebase, Auth0, etc.) without touching Navbar.jsx.
// Replace the internals here when you wire up your real auth system.

import { useAuth } from "Auth/authContext"

const useNavAuth = () => {
    const { user, logout } = useAuth()
    return { user, logout }
}

export default useNavAuth